// extracted by mini-css-extract-plugin
export default {"floatContent":"ButtonScroll_floatContent__l-LP1","controls":"ButtonScroll_controls__jOy-t","sdb07":"ButtonScroll_sdb07__Xbrc-"};